<template>
  <div>
   

    <DataTable
      :url="api.ACTIONS.COMPANY_REQUESTS"
      :titles="titles"
      :fields-hidden-main="['deleted_at', 'updated_at','info']"
      :fields-hidden-add="[]"
      :input-types-add="{}"
      :formatter="formatters"
      :title="$t('customers.companyRequests.title')"
      :enableEdit="false"
      :actions-extra-main="actionsExtraMain"
      :add-rules="rules"
      :enableAdd="false"
    />
  </div>
</template>
<style>
.cbtn {
  float: right;
  z-index: 1;
  margin-top: 20px;
  margin-right: 20px;
  padding: 0px 45px;
}
</style>
<script>
import DataTable from "@/components/monaco/DataTable";
import moment from "moment";

export default {
  name: "CompanyRequests",
  title() {
    return this.$t("customers.companyRequests.title");
  },
  components: { DataTable },
  data() {
    return {
      formatters: {
        created_at(value) {
          return moment(value).format(" DD MMM YYYY");
        },
        approved_at(value) {
          return value ? moment(value).format(" DD MMM YYYY"): '';
        },
      },
    };
  },
  computed: {
    rules() {
      return {
        
      };
    },
   

    titles() {
      return {
        id: "#",
        company_name: this.$t("customers.companyRequests.companyName"),
        contact_name: this.$t("customers.companyRequests.contactName"),
        email: this.$t("customers.companyRequests.email"),
        phone_number: this.$t("customers.companyRequests.phone"),
        legal_form: this.$t("customers.companyRequests.legalForm"),
        street: this.$t("customers.companyRequests.street"),
        no: this.$t("customers.companyRequests.no"),
        postal_code: this.$t("customers.companyRequests.postalCode"),
        city: this.$t("customers.companyRequests.city"),
        rci_no: this.$t("customers.companyRequests.rciNo"),
        email: this.$t("customers.companyRequests.email"),
        created_at: this.$t("customers.companyRequests.creationDate"),
        approved_at: this.$t("customers.companyRequests.approvalDate")
      };
    },
    actionsExtraMain() {
      return {
        prices: {
          title: this.$t("customers.companyRequests.companyRequest"),
          icon: "edit",
          action: (item) =>
            this.$router.push({
              name: "CompanyRequest",
              params: { id: item.id },
            }),
        },
      };
    },
  },
};
</script>
